import * as React from 'react'
import { MatchClasses } from '../../hooks'

import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import { SearchHelperPopup } from '@sales-center/components'
import { SearchSubHeader } from './Styled'

type Props = {
  styles: MatchClasses
  count: number
  searchText: string
  onChangeSearchText: React.ChangeEventHandler
}

export const SearchSection: React.FC<Props> = (props) => {
  const { styles, count, searchText, onChangeSearchText } = props

  const resultLabel = `${count} Possible ${
    count === 1 ? 'Location' : 'Locations'
  } `

  return (
    <>
      <SearchSubHeader>
        Search for Bill-To Locations from PestPac to find a Match
      </SearchSubHeader>
      <SearchHelperPopup />
      <Typography mt={2.0}>
        Search for and select a Bill-to record to display associated Service
        Locations to match. You can create additional Service Locations if
        needed.
      </Typography>
      <TextField
        value={searchText}
        onChange={onChangeSearchText}
        fullWidth
        size="small"
        sx={(styles.searchBox, { minHeight: 44 })}
      />
      <Typography>{resultLabel}</Typography>
    </>
  )
}
SearchSection.displayName = 'SearchSection'
